import script from "./ImageEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageEdit.vue?vue&type=script&lang=ts&setup=true"

import "./ImageEdit.vue?vue&type=style&index=0&id=3a48a8f8&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a48a8f8"]])

export default __exports__